<template>
  <div>
    <input
      ref="loader"
      type="file"
      style="display: none"
      @change="onInputChange"
    >
    <v-btn
      small
      text
      outlined
      color="blue-grey lighten-3"
      class="loader-button"
      @click="onBtnClick"
    >
      <v-icon left>
        mdi-table
      </v-icon>
      load
    </v-btn>
  </div>
</template>

<script>
// see:
// https://alligator.io/vuejs/csv-reader-component/
// https://www.papaparse.com/
import Papa from 'papaparse'

export default {
	name: 'CatalogLoader',

	methods: {
		onBtnClick(ev) {
			this.$refs.loader.click(ev)
		},
		onInputChange(ev) {
			const file = ev.target.files[0]

			// important : permet de re-sélectionner le même fichier ensuite
			ev.target.value = ''

			if (!file) return

			const reader = new FileReader()

			reader.onload = () => {
				this.$emit('load', {
					csv: Papa.parse(reader.result, { header: true }),
					fileName: file.name,
				})
			}

			reader.readAsText(file)
		},
	},
}
</script>

<style lang="scss">
.loader-button {
}
</style>
